export default "__VITE_ASSET__PllsBGFB__"